import React, { useState } from 'react';
import U3204ChatInput from './U3204ChatInput';
import U3204ConversationHeader from './U3204ConversationHeader';
import U3204ConversationSidebar from './U3204ConversationSidebar';
import U3204MessageList from './U3204MessageList';

const U3204ChatLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-full max-h-full min-h-0 w-full overflow-hidden rounded-lg border border-border bg-background">
      <U3204ConversationSidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed((v) => !v)}
      />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <U3204ConversationHeader />
        <U3204MessageList />
        <U3204ChatInput />
      </div>
    </div>
  );
};

export default U3204ChatLayout;
